import React from "react";
import { Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";

export default function LockedNotice({ title, body, ctaLabel, ctaTo }) {
  return (
    <div className="card-pb p-12 text-center max-w-2xl mx-auto" data-testid="locked-notice">
      <div className="w-16 h-16 rounded-full bg-[#FFFBF0] grid place-items-center mx-auto mb-5 border-2 border-[#C9A356]/30">
        <Lock className="w-7 h-7 text-[#C9A356]" />
      </div>
      <h2 className="font-heading text-2xl font-medium text-[#0A2540]">{title || "Awaiting approval"}</h2>
      <p className="text-[#475569] mt-3 leading-relaxed">
        {body || "This area unlocks after your initial consultation. Schedule your free site visit to get started."}
      </p>
      {ctaLabel && ctaTo && (
        <Link to={ctaTo} className="btn-accent mt-8 inline-flex" data-testid="locked-cta">
          {ctaLabel} <ArrowRight className="w-4 h-4 ml-2" />
        </Link>
      )}
    </div>
  );
}
